//#region src/core/i18n/text/time.ts
const prefix = "time.";
const currentText = {
	key: `${prefix}current`,
	text: "Current time"
};
const durationText = {
	key: `${prefix}duration`,
	text: "Duration"
};
const remainingText = {
	key: `${prefix}remaining`,
	text: "Remaining"
};
const elapsedSuffixText = {
	key: `${prefix}elapsedSuffix`,
	text: "{duration} elapsed"
};
const durationSuffixText = {
	key: `${prefix}durationSuffix`,
	text: "{duration} duration"
};
const remainingSuffixText = {
	key: `${prefix}remainingSuffix`,
	text: "{duration} remaining"
};
const showElapsedText = {
	key: `${prefix}showElapsed`,
	text: "Show elapsed time, {duration}."
};
const showDurationText = {
	key: `${prefix}showDuration`,
	text: "Show duration, {duration}."
};
const showRemainingText = {
	key: `${prefix}showRemaining`,
	text: "Show remaining time, {duration}."
};
const toggleElapsedText = {
	key: `${prefix}toggleElapsed`,
	text: "Toggle between elapsed and remaining time."
};
const toggleDurationText = {
	key: `${prefix}toggleDuration`,
	text: "Toggle between duration and remaining time."
};
const positionText = {
	key: `${prefix}position`,
	text: "{current} of {duration}"
};
const unknownText = {
	key: `${prefix}unknown`,
	text: "Media not loaded, unknown time."
};
//#endregion
export { currentText, durationSuffixText, durationText, elapsedSuffixText, positionText, remainingSuffixText, remainingText, showDurationText, showElapsedText, showRemainingText, toggleDurationText, toggleElapsedText, unknownText };
